import React from "react";
import "./TermsConditions.css";

const TermsConditions = () => {
  return (
    <div className="vt-terms-wrapper">
      <div className="vt-terms-container">
        <h1 className="vt-terms-title">Terms & Conditions</h1>

        <p>
          Welcome to CM Group of Companies. By accessing and using our website,
          you agree to comply with and be bound by the following terms and
          conditions. Please read them carefully before proceeding.
        </p>

        <h2>1. Company Information</h2>
        <p>
          CM Group of Companies was established in 2019 as an integrated
          organization connecting strategic land development and sustainable
          energy solutions. We deliver infrastructure projects built on
          environmental responsibility and long-term value.
        </p>

        <h2>2. Use of Website</h2>
        <p>
          You agree to use this website solely for lawful purposes. Any misuse,
          unauthorized access, or actions that disrupt the website’s operation,
          security, or functionality are strictly prohibited.
        </p>

        <h2>3. Information & Content</h2>
        <p>
          While we strive to ensure that all information on this website is
          accurate and up to date, CM Group of Companies does not guarantee the
          completeness or accuracy of all content. Information related to land,
          projects, capacities, and achievements may be updated without prior
          notice.
        </p>

        <h2>4. Projects & Services</h2>
        <p>
          Details regarding land development, renewable energy projects, and
          infrastructure services are provided for general information purposes
          only and do not constitute contractual commitments unless explicitly
          stated in writing.
        </p>

        <h2>5. Intellectual Property</h2>
        <p>
          All website content including text, graphics, logos, images, designs,
          and media is the intellectual property of CM Group of Companies.
          Unauthorized reproduction, distribution, or use of this content is
          strictly prohibited.
        </p>

        <h2>6. Limitation of Liability</h2>
        <p>
          CM Group of Companies shall not be held liable for any direct or
          indirect damages arising from the use or inability to use this
          website, including but not limited to technical issues, inaccuracies,
          or temporary unavailability.
        </p>

        <h2>7. External Links</h2>
        <p>
          This website may contain links to third-party websites for reference
          or convenience. CM Group of Companies is not responsible for the
          content, accuracy, or privacy practices of such external websites.
        </p>

        <h2>8. Changes to Terms</h2>
        <p>
          CM Group of Companies reserves the right to revise or update these
          Terms & Conditions at any time without prior notice. Continued use of
          the website signifies acceptance of the updated terms.
        </p>

        <h2>9. Governing Law</h2>
        <p>
          These Terms & Conditions shall be governed and interpreted in
          accordance with the laws of India. Any disputes shall be subject to
          the jurisdiction of the appropriate courts in India.
        </p>

        <h2>10. Contact Information</h2>
        <p>
          For questions or clarifications regarding these Terms & Conditions,
          please contact CM Group of Companies through our official communication
          channels.
        </p>
      </div>
    </div>
  );
};

export default TermsConditions;
